import React from 'react';
import PropTypes from 'prop-types';
import AutoSuggestionExitContainer from './AutoSuggestionExitContainer'
import AutoSuggestionEntranceContainer from './AutoSuggestionEntranceContainer'

const AutoSuggestionContainer = ({ launchpoint, ...otherProps }) => {
  if (launchpoint) {
    return <AutoSuggestionExitContainer {...otherProps} />
  }
  return <AutoSuggestionEntranceContainer {...otherProps} />
}

AutoSuggestionContainer.propTypes = {
  launchpoint: PropTypes.bool
}

export default AutoSuggestionContainer
